import React from 'react';
import { Card } from 'react-bootstrap';

const CardView = ({ 
    children, 
    title, 
    subtitle, 
    header, 
    footer, 
    bg, 
    text, 
    border, 
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    style, 
    className,
    ...props 
}) => {
    return (
        <Card bg={bg} text={text} border={border} className={className} style={style} {...props}>
            {header && <Card.Header>{header}</Card.Header>}
            <Card.Body className={className}>
                {title && <Card.Title>{title}</Card.Title>}
                {subtitle && <Card.Subtitle className="mb-2 text-muted">{subtitle}</Card.Subtitle>}
                {children}
            </Card.Body>
            {footer && <Card.Footer>{footer}</Card.Footer>}
        </Card>
    );
};

export default CardView;
